module.exports = __webpack_public_path__ + "img/3.e61c36f.png";